<template>
<div class="servicesPage">
	<div class="servicesImageBox" ref="headerImageRef">
		<img class="servicesImage" src="@/assets/servicesIMG.png" />
		<div class="servicesTextBox">
			<div class="servicesTitle" style="margin-top: 3rem;">
				AI+人工，全周期服务闭环<br />
                AI + Human Support: A Full-Cycle Service Closed-Loop
			</div>
			<div class="servicesText" style="margin-top: 3rem;">
				从筛查到跟踪，每一步都有专业支持<br />
                From screening to tracking—professional support at every step
			</div>
		</div>
	</div>

    <div style="height: 11.7rem; width: 1px;" />
    <div>
        <div style="width: 1px; height: 13.6%" />
        <div class="boxCNTitle">
            服务内容闭环
        </div>
        <div style="width: 1px; height: 1rem" />

        <div class="boxENTitle">
            SERVICE CONTENT CLOSED LOOP
        </div>
        <div style="height: 6.7rem; width: 1px;" />

        <img src="@/assets/services_loop.png" class="loopImage" />
    </div>
    <div style="height: 11.7rem; width: 1px;" />


    <div style="width: 1px; height: 6.7rem" />
    <div class="boxCNTitle">
        服务保障体系
    </div>
    <div style="width: 1px; height: 1rem" />

    <div class="boxENTitle">
        SERVICE GUARANTEE SYSTEM
    </div>

    <div style="width: 1px; height: 6.7rem" />
    <div class="systemBox">
        <div class="systemItem">
            <div style="width: 1px; height: 5.3rem" />
            <div class="systemTitle">
                专业支持
            </div>
            <div style="width: 1px; height: 1rem" />
            <div class="systemSub">
                PROFESSIONAL SUPPORT
            </div>
            <div style="width: 1px; height: 3.3rem" />

            <div class="systemLines">
                <div class="systemLine">
                    <img src="@/assets/text_deco.png" class="systemTextDeco" />
                    50 + 持二级心理咨询师
                </div>
                <div style="width: 1px; height: 1.7rem" />
                <div class="systemLine">
                    <img src="@/assets/text_deco.png" class="systemTextDeco" />
                    20 + 三甲医院专家团队
                </div>
            </div>
        </div>
        <div style="flex: 1; height: 1px;" />
        <div class="systemItem">
            <div style="width: 1px; height: 5.3rem" />
            <div class="systemTitle">
                技术保障
            </div>
            <div style="width: 1px; height: 1rem" />
            <div class="systemSub">
                TECHNICAL GUARANTEE
            </div>
            <div style="width: 1px; height: 3.3rem" />
            <div class="systemLines">
                <div class="systemLine">
                    <img src="@/assets/text_deco.png" class="systemTextDeco" />
                    7×24 小时系统运维
                </div>
                <div style="width: 1px; height: 1.7rem" />
                <div class="systemLine">
                    <img src="@/assets/text_deco.png" class="systemTextDeco" />
                    数据安全合规
                </div>
                <div style="width: 1px; height: 1.7rem" />
                <div class="systemLine">
                    <img src="@/assets/text_deco.png" class="systemTextDeco" />
                    隐私保护机制
                </div>
            </div>
        </div>
        <div style="flex: 1; height: 1px;" />
        <div class="systemItem">
            <div style="width: 1px; height: 5.3rem" />
            <div class="systemTitle">
                运营支持
            </div>
            <div style="width: 1px; height: 1rem" />
            <div class="systemSub">
                OPERATIONAL SUPPORT
            </div>
            <div style="width: 1px; height: 3.3rem" />
            <div class="systemLines">
                <div class="systemLine">
                    <img src="@/assets/text_deco.png" class="systemTextDeco" />
                    线上客服响应
                </div>
                <div style="width: 1px; height: 1.7rem" />
                <div class="systemLine">
                    <img src="@/assets/text_deco.png" class="systemTextDeco" />
                    线下活动落地
                </div>
                <div style="width: 1px; height: 1.7rem" />
                <div class="systemLine">
                    <img src="@/assets/text_deco.png" class="systemTextDeco" />
                    定期内容更新
                </div>
                <div style="width: 1px; height: 1.7rem" />
                <div class="systemLine">
                    <img src="@/assets/text_deco.png" class="systemTextDeco" />
                    用户培训指导
                </div>
            </div>
        </div>
    </div>
    <div style="height: 3.5rem; width: 1px;" />

</div>
</template>

<script>
export default {
	data() {
		return {
		}
	},
	methods: {

		emitHeroHeight() {
			const height = this.$refs.headerImageRef ? this.$refs.headerImageRef.offsetHeight : 20;
			this.$emit("headerImageRefHeight", height);
		}
	},
	created() {
	},
	mounted() {
		this.emitHeroHeight();
		window.addEventListener("resize", this.emitHeroHeight);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.emitHeroHeight);
	},
	watch: {
	},
}
</script>

<style lang="scss" scoped>
.servicesPage {
    display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	.servicesImageBox {
		width: 100%;
		height: 51.4rem;
		position: relative;
		background-color: #212121;

		.servicesImage {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0px;
			left: 0px;
			object-fit: cover;
		}

		.servicesTextBox {
			position: absolute;
			width: 1200px;
			left: calc((100% - 1200px) / 2);
			top: 20%;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: center;

			.servicesTitle {
				font-size: 5.3rem;
				text-align: left;
				color: #FFFFFF;
			}
			.servicesText {
				font-size: 1.5rem;
				line-height: 2.5rem;
				text-align: left;
				color: #FFFFFF;
			}
		}
	}

    .loopImage {
        width: 90.8rem;
        height: auto;
    }

    .systemBox {
        box-sizing: border-box;
        width: 100rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        column-gap: 2rem;

        .systemItem {
            width: 32rem;
            height: 36.9rem;
            box-shadow: 0px 0.3rem 3.3rem 0px rgba(51, 51, 51, 0.05);
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;

            .systemTitle {
                font-size: 2rem;
                line-height: 3rem;
                color: #333333;
            }

            .systemSub {
                font-size: 1.3rem;
                line-height: 2rem;
                color: #333333;
                opacity: 0.8;
            }

            .systemLines {
                display: inline-flex;
                flex-direction: column;
                align-items: flex-start;
            }

            .systemLine {
                font-size: 1.5rem;
                line-height: 2.4rem;
                color: #333333;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                white-space: nowrap;

                .systemTextDeco {
                    width: 1.7rem;
                    height: 1.7rem;
                    margin-right: 1rem;
                    position: relative;
                    flex-shrink: 0;
                }
            }
        }
    }
	
}

.boxCNTitle{
	font-size: 4rem;
	line-height: 4.8rem;
	color: #1D1D1F;
	font-weight: 600;
}
.boxENTitle{
	font-size: 1.7rem;
	line-height: 1.8rem;
	color: #666666;
}
</style>